import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { CollapseModule } from "ngx-bootstrap/collapse";
import { SinceDatePipe } from './since-date.pipe';


@NgModule({
  declarations: [
    HeaderComponent,
    SinceDatePipe
  ],
  exports: [
    HeaderComponent,
    SinceDatePipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    CollapseModule
  ]
})
export class SharedModule {
}
